// Constantes pour les points de contrôle et réponses
// Inspiré de l'ancienne app React (Reducer/NewVisit et Reducer/ExportVisit)

// Points de qualité pour les observations
export const QUALITY_POINTS = [
  { label: 'Bon', value: 'G' },
  { label: 'Moyen', value: 'A' },
  { label: 'Dégradé', value: 'D' },
  { label: 'Sans objet', value: 'U' }
]

// Points Oui/Non pour les questions binaires
export const YESNO_POINTS = [
  { label: 'Oui', value: 'Y' },
  { label: 'Non', value: 'N' },
  { label: 'Sans objet', value: 'U' }
]

// Points pour le statut relouable
export const RENTABLE_POINTS = [
  { label: "en l'état", value: 'I' },
  { label: "avec travaux d'embellissement", value: 'NW' },
  { label: "avec travaux lourds", value: 'NHW' }
]

// Points pour le statut relouable (format formulaire NewVisit)
export const RENTABLE_FORM_POINTS = [
  { label: 'Immédiatement', value: 1 },
  { label: 'Après travaux', value: 2 },
  { label: 'Non relouable', value: 3 }
]

// Points Oui/Non pour les travaux (format formulaire NewVisit)
export const YESNO_FORM_POINTS = [
  { label: 'Oui', value: 1 },
  { label: 'Non', value: 2 }
]

// Export par défaut pour faciliter l'import
export default {
  QUALITY_POINTS,
  YESNO_POINTS,
  RENTABLE_POINTS,
  RENTABLE_FORM_POINTS,
  YESNO_FORM_POINTS
}
